import { render, staticRenderFns } from "./TicketsPurchased.vue?vue&type=template&id=887aeb6c&scoped=true&"
import script from "./TicketsPurchased.vue?vue&type=script&lang=js&"
export * from "./TicketsPurchased.vue?vue&type=script&lang=js&"
import style0 from "./TicketsPurchased.vue?vue&type=style&index=0&id=887aeb6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887aeb6c",
  null
  
)

export default component.exports